import { resetErrorFieldStyle, txtFormatChecker } from "../Variables";
import { useContextStateManagement } from "../context/ContextApi";
import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../features/userSlice";
import { useNavigate } from "react-router-dom";
import { TimeZoneDropdown } from "./TimeZoneDropdown";
import { CopyLink } from "./CopyLink";
import { PromptHubStepLayout } from "./PromptHubStepLayout";
import { usePersistedState } from "../hooks/usePersistedState";
import "../components/Auth/Auth.css";

const CHATG_PROVIDER_ID_STORAGE_KEY = "cm_chatG_providerId";

export const ChatGOnBoardingForm = () => {
    const { PracticeId, practiceName, token, usersPostRequest, setToken, fetchUserRecord, activeTab, userType, setUserType, practiceContactNumber } = useContextStateManagement();
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [ragFile, setRagFile] = useState("");
    const [promptFile, setPromptFile] = useState("");
    const [ragFiledownloadLink, setRagFileDownloadLink] = useState("");
    const [promptFiledownloadLink, setPromptFiledownloadLink] = useState("");
    const [providerId, setProviderId] = useState("")
    const [providerData, setProviderData] = useState([]);
    const [providerName, setProviderName] = useState("");
    const [providerFacilityName, setProviderFacilityName] = useState("");
    // const [providerSpecialtyType, setProviderSpecialtyType] = useState("");
    // const [providerContactNumber, setProviderContactNumber] = useState("");
    // const [additionalOfferedService, setAdditionalOfferedService] = useState("EKG");
    // const [additionalOfferedServiceDetail, setAdditionalOfferedServiceDetail] = useState("");
    // const [betterServicesReason, setBetterServicesReason] = useState("");
    // const [selectedModal, setSelectedModal] = useState("");
    // const [selectedVoice, setSelectedVoice] = useState("");
    // const [firstMessage, setFirstMessage] = useState("");
    // const [lastMessage, setLastMessage] = useState("");
    // const [status, setStatus] = useState("");
    // const [apiKeys, setApiKeys] = useState("");
    // const [selectedVoiceModal, setSelectedVoiceModal] = useState("");
    const [chatbotType, setChatbotType] = useState("");
    const [selectedTimezone, setSelectedTimezone] = useState("");
    const [currentStep, setCurrentStep] = usePersistedState("cm_chatG_currentStep", 1);
    const restoredProviderRef = useRef(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let formData = new FormData();
    let isAnyUploadFieldEmpty = false;

    const getElement = (id) => document.getElementById(id);
    const enableElement = (id) => getElement(id)?.removeAttribute("disabled");
    const setElementValue = (id, value) => {
        const element = getElement(id);
        if (element) {
            element.value = value;
        }
    };
    const removeInvalidClass = (id) => getElement(id)?.classList.remove("invalid-details");

    const handleTimezoneChange = (e) => {
        setSelectedTimezone(e.target.value);
    };

    function resetInputFieldsColor() {
        document
            .querySelectorAll("input.invalid-details, textarea.invalid-details, select.invalid-details, .invalid-details")
            .forEach((element) => {
                element?.classList?.remove("invalid-details");
            });
    }

    const fetchApiHandle = async () => {
        let url = `/api/ChatbotOnboarding/${PracticeId}`;
        const userData = await fetchUserRecord(token, url);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else {
            setProviderData(userData)
        }
    }

    const resetForm = () => {
        setProviderId("");
        setProviderName("");
        setRagFileDownloadLink("");
        setPromptFiledownloadLink("");
        setRagFile("");
        setPromptFile("");
        setChatbotType("");
        setSelectedTimezone("");
        resetInputFieldsColor();
    }

    const updateForm = (e) => {

        let pId = e.target.value;

        if (pId) {
            const selectedProvider = providerData.length > 0 ? providerData.filter((provider) => provider.Id == pId) : "";
            const selectedProviderData = selectedProvider[0];
            setProviderId(selectedProviderData.Id);
            sessionStorage.setItem(CHATG_PROVIDER_ID_STORAGE_KEY, String(selectedProviderData.Id));
            setProviderName(selectedProviderData.ProviderName);
            setRagFileDownloadLink(selectedProviderData.RAGFileUrl ? selectedProviderData.RAGFileUrl : "");
            setPromptFiledownloadLink(selectedProviderData.PromptFileUrl ? selectedProviderData.PromptFileUrl : "");
            setChatbotType(selectedProviderData.ChatBotType ? selectedProviderData.ChatBotType : "")
            setSelectedTimezone(selectedProviderData.Timezone ? selectedProviderData.Timezone : "");
            resetInputFieldsColor();
        }
        else {
            sessionStorage.removeItem(CHATG_PROVIDER_ID_STORAGE_KEY);
            resetForm();
        }

        // document.getElementById("submitButtonForm").removeAttribute("disabled");
    }

    const handleRagFileChange = (e) => {
        enableElement("submitButtonForm");
        let file = e.target.files[0];
        if (file) {
            if (txtFormatChecker(file)) {
                setRagFile(file)
            }
            else {
                setElementValue("ragFile", "");
                alert('Require format is not txt');
            }
        }
        else {
            setRagFile("");
            // document.getElementById('ragFile').classList.add("invalid-details");
        }
    }

    const handlePromptFileChange = (e) => {
        enableElement("submitButtonForm");
        let file = e.target.files[0];
        if (file) {
            if (txtFormatChecker(file)) {
                setPromptFile(file);
            }
            else {
                setElementValue("dynamicPrompt", "");
                alert('Require format is not txt');
            }
        }
        else {
            setPromptFile("");
            // document.getElementById('dynamicPrompt').classList.add("invalid-details");
        }
    }

    const handleSubmit = async (e) => {
        // debugger
        e.target.disabled = true;

        document.querySelectorAll('.px-3').forEach((e) => {
            if (e.value === "") {
                e.classList.add("invalid-details")
            }
        })

        if (providerName === "" || chatbotType === "" || ((!providerId && !ragFiledownloadLink && !ragFile) || (providerId && !ragFiledownloadLink && !ragFile)) || promptFile === "" || selectedTimezone === "") {
            isAnyUploadFieldEmpty = true;
        }
        else {
            isAnyUploadFieldEmpty = false;
        }

        if ((userType === "admin") || (userType === "client")) {
            if (providerId && ragFile || ragFiledownloadLink && !ragFile) {
                removeInvalidClass("ragFile");
            }

            if (providerId && promptFile || promptFiledownloadLink && !promptFile) {
                removeInvalidClass("dynamicPrompt");
            }

            if (ragFile && promptFile && providerName && chatbotType && selectedTimezone) {
                isAnyUploadFieldEmpty = false;
            }

            if (providerId && providerName && chatbotType && selectedTimezone && ((!ragFile && ragFiledownloadLink) || (!promptFile && promptFiledownloadLink))) {
                isAnyUploadFieldEmpty = false;
            }

        }

        if (isAnyUploadFieldEmpty === true) {
            alert('Please enter complete details of onboarding')
            enableElement("submitButtonForm");
            return
        }

        // Using form data for sending the choose files from front end to the server
        formData.append('RAGFile', ragFile);
        formData.append('PromptFile', promptFile);

        if (ragFile !== "") {
            formData.append('RAGFileUrl', "");
        }
        else {
            formData.append('RAGFileUrl', ragFiledownloadLink);
        }

        if (promptFile !== "") {
            formData.append('PromptFileUrl', "");
        }
        else {
            formData.append('PromptFileUrl', promptFiledownloadLink);
        }

        formData.append('PracticeId', PracticeId);
        formData.append('ProviderId', providerId);
        formData.append('ProviderName', providerName);
        formData.append('ProviderFacilityName', providerFacilityName);
        formData.append('ChatBotType', chatbotType);
        formData.append('Timezone', selectedTimezone);

        let url = '/api/ChatbotOnboarding';
        const userData = await usersPostRequest(token, url, formData);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else if (userData && userData.message) {
            alert(userData.message)
            fetchApiHandle()
        }

        setProviderId("");
        sessionStorage.removeItem(CHATG_PROVIDER_ID_STORAGE_KEY);
        setProviderName("");
        setChatbotType("");
        setSelectedTimezone("");
        setElementValue("selected_Provider", "");
        setElementValue("chatbotType", "");

        if ((userType === "admin") || (userType === "client")) {
            setRagFileDownloadLink("");
            setPromptFiledownloadLink("");
            setRagFile("");
            setPromptFile("");
            setElementValue("ragFile", "");
            setElementValue("dynamicPrompt", "");
            setElementValue("selected_timezone", "");
        }
        e.target.disabled = false;
    };


    // Token-expiry redirect is now handled once, centrally, in ContextApi.js - see its comment
    // for why this component's own copy of the same effect was removed.

    useEffect(() => {
        if (activeTab || PracticeId) {
            fetchApiHandle();
            resetForm();
            setProviderFacilityName(practiceName);
        }
    }, [activeTab, PracticeId])

    // After a refresh, once the provider list has loaded, re-select whichever
    // provider was being edited before instead of leaving the form on blank.
    useEffect(() => {
        if (restoredProviderRef.current) return;
        if (!providerData || providerData.length === 0) return;

        const persistedProviderId = sessionStorage.getItem(CHATG_PROVIDER_ID_STORAGE_KEY);
        if (persistedProviderId) {
            const match = providerData.find(
                (provider) => String(provider.Id) === persistedProviderId
            );
            if (match) {
                updateForm({ target: { value: String(match.Id) } });
                setElementValue("selected_Provider", String(match.Id));
            } else {
                sessionStorage.removeItem(CHATG_PROVIDER_ID_STORAGE_KEY);
            }
        }
        restoredProviderRef.current = true;
    }, [providerData]);

    const nextStep = () => {
        setCurrentStep((step) => Math.min(step + 1, 3));
    };

    const previousStep = () => {
        setCurrentStep((step) => Math.max(step - 1, 1));
    };

    // useEffect(() => {
    //     if (providerName !== "" || ragFile !== "" || promptFile !== "") {
    //         document.getElementById("submitButtonForm").removeAttribute("disabled");
    //     }
    //     else {
    //         document.getElementById("submitButtonForm").setAttribute("disabled", "true");
    //     }
    // }, [providerName, ragFile, promptFile]);


    return (
        <PromptHubStepLayout
            title="ChatG Prompt Hub"
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            onBack={previousStep}
            onNext={nextStep}
            onSubmit={handleSubmit}
            onExit={() => navigate("/inbound")}
            exitLabel="Back to Console"
            showQuickSave={Boolean(providerId)}
            submitLabel={providerId ? "Save changes" : "Publish"}
        >
            {currentStep === 1 ? (
                <section className="auth-form-section auth-step-panel" key="chatg-step-1">
                    <div className="auth-form-section__header auth-step-panel__header">
                        <div>
                            <p className="auth-step-panel__eyebrow">Step 1</p>
                            <h3 className="auth-form-section__title">Basic Details</h3>
                        </div>
                    </div>
                    <div className="col">
                        <div className="mb-3">
                            <label className="text-white form-label mt-3">Clinic/Facility Name</label>
                            <input type="text" onChange={(e) => setProviderFacilityName(e.target.value)} disabled onFocus={resetErrorFieldStyle} className="bg-black text-white border-0 py-2 px-3 form-control" value={providerFacilityName} id="ProviderFacilityName" placeholder="Enter your clinic name" />
                        </div>
                        <div className="mb-3">
                            <label className="text-white form-label">Select Provider to edit</label>
                            <select className="bg-black border-0 text-white py-2 padding_left form-select" id="selected_Provider" onChange={updateForm}>
                                <option className="selectedProviderOption" value="">Select Provider</option>
                                {
                                    providerData.length > 0 ?
                                        providerData.map((provider) => {
                                            return (
                                                <option key={provider.Id} className="selectedProviderOption" value={provider.Id}>{provider.ProviderName}</option>
                                            );
                                        })
                                        : ""
                                }
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className="text-white form-label">Provider Name</label>
                            <input type="text" onChange={(e) => setProviderName(e.target.value)} value={providerName} onFocus={resetErrorFieldStyle} className="bg-black text-white border-0 py-2 px-3 form-control" id="ProviderName" placeholder="Enter your clinic name" />
                        </div>
                        <div className="mb-0">
                            <label className="text-white form-label">Select chatbot</label>
                            <select className="bg-black border-0 text-white py-2 px-3 form-select" id="chatbotType" value={chatbotType} onChange={(e) => setChatbotType(e.target.value)} onFocus={resetErrorFieldStyle} >
                                <option className="selectedProviderOption" value="">Select chatbot type</option>
                                <option className="selectedProviderOption" value="questionnaire">Questionnaire</option>
                                <option className="selectedProviderOption" value="conversational">Conversational</option>
                            </select>
                        </div>
                    </div>
                </section>
            ) : null}

            {currentStep === 2 ? (
                <section className="auth-form-section auth-step-panel" key="chatg-step-2">
                    <div className="auth-form-section__header auth-step-panel__header">
                        <div>
                            <p className="auth-step-panel__eyebrow">Step 2</p>
                            <h3 className="auth-form-section__title">Configuration</h3>
                        </div>
                    </div>
                    <div className="col">
                        <div className="mb-3">
                            <label className="text-white form-label">Upload RAG File</label>
                            <input type="file" onChange={handleRagFileChange} accept={".txt"} className="bg-black text-white border-0 py-2 px-3 form-control" onFocus={resetErrorFieldStyle} id="ragFile" />
                            {
                                ragFiledownloadLink && (
                                    <a href={ragFiledownloadLink} target="blank" download={ragFiledownloadLink} style={{ display: "block" }} id="downloadLink">
                                        View File
                                    </a>
                                )
                            }
                        </div>
                        <div className="mb-3">
                            <label className="text-white form-label">Upload Dynamic Prompt File</label>
                            <input type="file" onChange={handlePromptFileChange} accept={".txt"} className="bg-black text-white border-0 py-2 px-3 form-control" onFocus={resetErrorFieldStyle} id="dynamicPrompt" />
                            {
                                promptFiledownloadLink && (
                                    <a href={promptFiledownloadLink} target="blank" download={promptFiledownloadLink} style={{ display: "block" }} id="downloadLink">
                                        View File
                                    </a>
                                )
                            }
                        </div>
                        <TimeZoneDropdown selectedTimezone={selectedTimezone} onChange={handleTimezoneChange} />
                        <div className="mt-3">
                            <CopyLink label={"Chatbot link"} link={`https://chat.allyzent.com/${practiceContactNumber}`} />
                        </div>
                    </div>
                </section>
            ) : null}

            {currentStep === 3 ? (
                <section className="auth-form-section auth-step-panel" key="chatg-step-3">
                    <div className="auth-form-section__header auth-step-panel__header">
                        <div>
                            <p className="auth-step-panel__eyebrow">Step 3</p>
                            <h3 className="auth-form-section__title">Review & Publish</h3>
                        </div>
                    </div>

                    <div className="auth-review-grid">
                        <div className="auth-review-card">
                            <p className="auth-review-card__title">Assistant details</p>
                            <dl className="auth-review-list">
                                <div className="auth-review-list__row">
                                    <dt>Facility</dt>
                                    <dd>{providerFacilityName || "Not added"}</dd>
                                </div>
                                <div className="auth-review-list__row">
                                    <dt>Provider</dt>
                                    <dd>{providerName || "Not added"}</dd>
                                </div>
                                <div className="auth-review-list__row">
                                    <dt>Chatbot</dt>
                                    <dd>{chatbotType || "Not selected"}</dd>
                                </div>
                                <div className="auth-review-list__row">
                                    <dt>Timezone</dt>
                                    <dd>{selectedTimezone || "Not selected"}</dd>
                                </div>
                            </dl>
                        </div>

                        <div className="auth-review-card">
                            <p className="auth-review-card__title">Uploaded assets</p>
                            <dl className="auth-review-list">
                                <div className="auth-review-list__row">
                                    <dt>RAG file</dt>
                                    <dd>{ragFile?.name || ragFiledownloadLink || "Not added"}</dd>
                                </div>
                                <div className="auth-review-list__row">
                                    <dt>Prompt file</dt>
                                    <dd>{promptFile?.name || promptFiledownloadLink || "Not added"}</dd>
                                </div>
                                <div className="auth-review-list__row">
                                    <dt>Chatbot link</dt>
                                    <dd>{practiceContactNumber ? `chat.allyzent.com/${practiceContactNumber}` : "Not available"}</dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </section>
            ) : null}
        </PromptHubStepLayout>
    );
};

